export function getRootUrl(): string {
  const { protocol, hostname } = window.location;
  if (hostname === 'localhost' || hostname.endsWith('.localhost')) {
    return `${protocol}//localhost:${window.location.port}`;
  }
  const parts = hostname.split('.');
  const domain = parts.slice(-2).join('.');
  return `${protocol}//${domain}`;
}

export function getDemoUrl(): string {
  const { protocol, hostname, port } = window.location;
  if (hostname === 'localhost' || hostname.endsWith('.localhost')) {
    return `${protocol}//demo.localhost:${port}`;
  }
  const parts = hostname.split('.');
  const domain = parts.slice(-2).join('.');
  return `${protocol}//demo.${domain}`;
}
